import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService as ApiLogin } from 'src/app/services/login/api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  redirectUrl: any;
  baseUrl: string = environment.apiURL;

  constructor(private httpClient: HttpClient) { }

  public sendContact(topic: string, full_name: string, email: string, message: string) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
    const data = JSON.stringify({
        "topic": topic,
        "full_name": full_name,
        "email": email,
        "message": message
      })
    return this.httpClient.post<any>(`${this.baseUrl}visitor-message`, data, { headers: httpHeaders })
      .pipe(map(response => {
        return response;
      }));
  }
}
